import { removeDuplicateData } from '../../../../src/lib/helpers';
import startupApi from '../../../../src/apis/startupApi';
import { ALLOWED_QUERY_OPERATOR, FUNDING_VERIFICATION_STATUS } from '../../../../src/lib/constants';


export const getMetaDescription = (startupDescription) => {
    let metadescription;
    if (startupDescription) {
        metadescription = startupDescription.replace(/<\/?[^>]+(>|$)/g, "");
        metadescription = metadescription.replace(/&nbsp;/g, ' ');
        if (metadescription !== undefined && metadescription !== null && metadescription.length > 300) {
            metadescription = metadescription.substr(0, 300);
            metadescription = metadescription.substr(0, metadescription.lastIndexOf(' ')) + ' ...';
        }
    }

    return metadescription;
}

export const getStartupInvestors = async (data, entityType = 'startup') => {

    if (data?.length > 0) {
        const page = 1;
        const limit = 20; // this api returns duplicate records, so more limit is required
        const filter = [
            {
                key: 'verification_status_filter',
                value: [FUNDING_VERIFICATION_STATUS.draft],
                op: ALLOWED_QUERY_OPERATOR.notEq
            }
        ];

        const investorsDataPromises = data.map(item =>
            startupApi.getInvestors(item.id, entityType, limit, page, filter)
        );

        const investorsDataResponses = await Promise.all(investorsDataPromises);

        for (let i = 0; i < data.length; i++) {
            let investors = investorsDataResponses[i].records
                .map(record => record.entity_data)
                .filter(entity_data => entity_data !== null);

            investors = removeDuplicateData(investors);

            data[i].investors_data = investors;
        }
    }

    return data;
}

export const getStartupBenchmarkingData = async (id, hasDirectoryAccess) => {
    let benchmarkingData = [];
    if (hasDirectoryAccess && id) {
        const benchmarkingResponse = await startupApi.getStartupBenchmarking(id);
        benchmarkingData = await getStartupInvestors(benchmarkingResponse);
    }
    return benchmarkingData;
}
